<div class="col-lg-12 no-padd main-title">
    Logging out...
</div>